import { render, staticRenderFns } from "./backup-restore.vue?vue&type=template&id=51ac8869&scoped=true&"
import script from "./backup-restore.vue?vue&type=script&lang=js&"
export * from "./backup-restore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ac8869",
  null
  
)

/* custom blocks */
import block0 from "./backup-restore.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports